import { useGetMaterialRequestParamsMutation } from '../../redux/api/material-request.ts';
import { useEffect, useState } from 'react';
import { Button, Card, Empty, Modal, Typography } from 'antd';
import CustomResponsiveTable from '../../components/CustomResponsiveTable';
import { Link } from 'react-router-dom';

interface IMaterialOrderRequestRelated {
	visible: boolean;
	idsMaterialRequestsRelated: string[];
	onCancel: (value: boolean) => void;
}

export const MaterialOrderRequestsRelated = ({
	visible,
	idsMaterialRequestsRelated,
	onCancel,
}: IMaterialOrderRequestRelated) => {
	const [fetchMaterialRequests, { data, isLoading, isError }] =
		useGetMaterialRequestParamsMutation();
	const [materialRequests, setMaterialRequests] = useState([]);

	useEffect(() => {
		if (visible && idsMaterialRequestsRelated?.length > 0) {
			const params = `?ids=${idsMaterialRequestsRelated.join(',')}`;
			fetchMaterialRequests(params)
				.unwrap()
				.then((response) => {
					setMaterialRequests(response.results);
				})
				.catch((error) => {
					console.error('Error fetching material requests:', error);
				});
		}
	}, [visible, idsMaterialRequestsRelated]);

	const columns = [
		{
			title: 'Vendor',
			render: (record) => record.vendor_material?.vendor?.display_name,
		},
		{
			title: 'Part #',
			render: (record) => record.vendor_material?.vendor_part_number,
		},
		{
			title: 'Material',
			render: (record) => (
				<>
					{record?.display_name} x {record?.material_cut_length} L.
				</>
			),
		},
		{
			title: 'Building',
			render: (record) => record.building?.name ?? '—',
		},
		// {
		// 	title: 'Shape',
		// 	render: (record) => record.vendor_material?.shape?.display_name,
		// },
		// {
		// 	title: 'Size',
		// 	render: (record) => record.display_size,
		// },
		{
			title: 'Requested Length',
			render: (record) => {
				return <>{record.total_required_length}</>;
			},
		},
		{
			title: 'Request for Job',
			render: (record) => (
				<div>
					{record.order_line_item?.order?.name ? (
						<Link
							target="_blank"
							rel="noreferrer"
							to={`/orders/${record.order_line_item?.order?.id}/`}
						>
							<Typography.Text strong copyable={true}>
								{record.order_line_item?.order?.name}
							</Typography.Text>
						</Link>
					) : null}
					{record.order_line_item?.order?.name ? (
						<Link
							target="_blank"
							rel="noreferrer"
							to={`/orders/line-items/${record.order_line_item?.id}/`}
						>
							<Typography.Text copyable={true}>
								{record.order_line_item?.name}
							</Typography.Text>
						</Link>
					) : null}
				</div>
			),
		},
		// {
		// 	title: 'Status',
		// 	render: (record) => record.status,
		// }
	];

	const emptyTable = () => {
		return (
			<Empty
				image={Empty.PRESENTED_IMAGE_SIMPLE}
				description={
					<span style={{ color: '#000' }}>No material requests related</span>
				}
			/>
		);
	};

	return (
		<Modal
			title="Related Material Requests"
			open={visible}
			onCancel={() => onCancel(false)}
			width={1400}
			centered
			footer={[
				<Button key="cancel" onClick={() => onCancel(false)}>
					Close
				</Button>,
			]}
		>
			<Card className="shadow-sm" style={{ border: 'none' }}>
				<div style={{ display: 'flex', flexDirection: 'column' }}>
					<CustomResponsiveTable
						columns={columns}
						data={materialRequests}
						scroll={{ y: `calc(95vh - 250px)`, x: 'auto' }}
						loading={isLoading}
						emptyTable={emptyTable}
						pagination={false}
					/>
				</div>
			</Card>
		</Modal>
	);
};
